module.exports = __webpack_public_path__ + "621e7692e1f8c0e62907e12530ce76e0.png";